import { configureStore } from '@reduxjs/toolkit';
import inventoryReducer, { InventoryState } from './slices/inventorySlice';
import userProductsReducer, { UserProductsState } from './slices/userProductsSlice';

export interface RootState {
  inventory: InventoryState;
  userProducts: UserProductsState;
}

export const store = configureStore({
  reducer: {
    inventory: inventoryReducer,
    userProducts: userProductsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
